<template>
    <section id="pricing" class="section price-plan-area overflow-hidden ptb_100">
        <div class="container">
            <div class="row justify-content-center">
                <div class="col-12 col-lg-8">
                    <div class="row price-plan-wrapper">
                        <div class="col-12 col-md-6">
                            <!-- Single Price Plan -->
                            <div class="single-price-plan color-1 bg-hover hover-top text-center p-5">
                                <!-- Plan Title -->
                                <div class="plan-title mb-2 mb-sm-3">
                                    <h3 class="mb-2">Basic</h3>
                                    <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Amet, nemo.</p>
                                </div>
                                <!-- Plan Price -->
                                <div class="plan-price pb-2 pb-sm-3">
                                    <span class="color-primary fw-7">$</span>
                                    <span class="h1 fw-7">49</span>
                                    <sub class="validity text-muted fw-5">/mo</sub>
                                </div>
                                <!-- Plan Description -->
                                <div class="plan-description">
                                    <ul class="plan-features">
                                        <li class="py-2">5GB Linux Web Space</li>
                                        <li class="py-2">5 MySQL Databases</li>
                                        <li class="py-2 text-muted">24/7 Tech Support</li>
                                        <li class="py-2 text-muted">Daily Backups</li>
                                    </ul>
                                </div>
                                <!-- Plan Button -->
                                <div class="plan-button">
                                    <a href="#" class="btn btn-bordered mt-3">Get Started</a>
                                </div>
                            </div>
                        </div>
                        <div class="col-12 col-md-6 mt-4 mt-md-0">
                            <!-- Single Price Plan -->
                            <div class="single-price-plan color-2 bg-hover active hover-top text-center p-5">
                                <!-- Plan Title -->
                                <div class="plan-title mb-2 mb-sm-3">
                                    <h3 class="mb-2">Pro <sup><span class="badge badge-pill badge-warning ml-2">Save 20%</span></sup></h3>
                                    <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Amet, nemo.</p>
                                </div>
                                <!-- Plan Price -->
                                <div class="plan-price pb-2 pb-sm-3">
                                    <span class="color-primary fw-7">$</span>
                                    <span class="h1 fw-7">129</span>
                                    <sub class="validity text-muted fw-5">/mo</sub>
                                </div>
                                <!-- Plan Description -->
                                <div class="plan-description">
                                    <ul class="plan-features">
                                        <li class="py-2">10GB Linux Web Space</li>
                                        <li class="py-2">50 MySQL Databases</li>
                                        <li class="py-2">Unlimited Email</li>
                                        <li class="py-2">Daily Backups</li>
                                    </ul>
                                </div>
                                <!-- Plan Button -->
                                <div class="plan-button">
                                    <a href="#" class="btn btn-bordered mt-3">Get Started</a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row justify-content-center pt-5">
                <div class="col-12">
                    <!-- FAQ Content -->
                    <div class="faq-content">
                        <!-- sApp Accordion -->
                        <div class="accordion" id="sApp-accordion">
                            <div class="row justify-content-center">
                                <div class="col-12 col-md-6">
                                    <!-- Single Card -->
                                    <div class="card border-0">
                                        <!-- Card Header -->
                                        <div class="card-header bg-inherit border-0 p-0">
                                            <h2 class="mb-0">
                                                <button class="btn px-0 py-3" type="button">
                                                    What is a digital agency?
                                                </button>
                                            </h2>
                                        </div>
                                        <!-- Card Body -->
                                        <div class="card-body px-0 py-3">
                                            The point of using Lorem Ipsum is that it has a more-or-less normal distribution of letters, as opposed to using 'Content here, content here', making it look like readable English. Many desktop publishing packages and web page editors now use Lorem Ipsum as their default model text.
                                        </div>
                                    </div>
                                    <!-- Single Card -->
                                    <div class="card border-0">
                                        <!-- Card Header -->
                                        <div class="card-header bg-inherit border-0 p-0">
                                            <h2 class="mb-0">
                                                <button class="btn px-0 py-3" type="button">
                                                    How to start SEO business?
                                                </button>
                                            </h2>
                                        </div>
                                        <!-- Card Body -->
                                        <div class="card-body px-0 py-3">
                                            Contrary to popular belief, Lorem Ipsum is not simply random text. It has roots in a piece of classical Latin literature from 45 BC, making it over 2000 years old. Richard McClintock, a Latin professor at Hampden-Sydney College in Virginia, looked up one of the more obscure Latin words, consectetur, from a Lorem Ipsum passage, and going through the cites of the word in classical literature, discovered the undoubtable source.
                                        </div>
                                    </div>
                                    <!-- Single Card -->
                                    <div class="card border-0">
                                        <!-- Card Header -->
                                        <div class="card-header bg-inherit border-0 p-0">
                                            <h2 class="mb-0">
                                                <button class="btn px-0 py-3" type="button">
                                                    How to use marketing services?
                                                </button>
                                            </h2>
                                        </div>
                                        <!-- Card Body -->
                                        <div class="card-body px-0 py-3">
                                            It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.
                                        </div>
                                    </div>
                                    <!-- Single Card -->
                                    <div class="card border-0">
                                        <!-- Card Header -->
                                        <div class="card-header bg-inherit border-0 p-0">
                                            <h2 class="mb-0">
                                                <button class="btn px-0 py-3" type="button">
                                                    Is the Contact form active?
                                                </button>
                                            </h2>
                                        </div>
                                        <!-- Card Body -->
                                        <div class="card-body px-0 py-3">
                                            Contrary to popular belief, Lorem Ipsum is not simply random text. It has roots in a piece of classical Latin literature from 45 BC, making it over 2000 years old. Richard McClintock, a Latin professor at Hampden-Sydney College in Virginia, looked up one of the more obscure Latin words, consectetur, from a Lorem Ipsum passage, and going through the cites of the word in classical literature, discovered the undoubtable source.
                                        </div>
                                    </div>
                                </div>
                                <div class="col-12 col-md-6">
                                    <!-- Single Card -->
                                    <div class="card border-0">
                                        <!-- Card Header -->
                                        <div class="card-header bg-inherit border-0 p-0">
                                            <h2 class="mb-0">
                                                <button class="btn px-0 py-3" type="button">
                                                    How can I use the portfolio?
                                                </button>
                                            </h2>
                                        </div>
                                        <!-- Card Body -->
                                        <div class="card-body px-0 py-3">
                                            Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem aperiam, eaque ipsa quae ab illo inventore veritatis et quasi architecto beatae vitae dicta sunt explicabo. Nemo enim ipsam voluptatem quia voluptas sit aspernatur aut odit aut fugit, sed quia consequuntur magni dolores eos qui ratione voluptatem sequi nesciunt.
                                        </div>
                                    </div>
                                    <!-- Single Card -->
                                    <div class="card border-0">
                                        <!-- Card Header -->
                                        <div class="card-header bg-inherit border-0 p-0">
                                            <h2 class="mb-0">
                                                <button class="btn px-0 py-3" type="button">
                                                    What other services do you offer?
                                                </button>
                                            </h2>
                                        </div>
                                        <!-- Card Body -->
                                        <div class="card-body px-0 py-3">
                                            There are many variations of passages of Lorem Ipsum available, but the majority have suffered alteration in some form, by injected humour, or randomised words which don't look even slightly believable. If you are going to use a passage of Lorem Ipsum, you need to be sure there isn't anything embarrassing hidden in the middle of text.
                                        </div>
                                    </div>
                                    <!-- Single Card -->
                                    <div class="card border-0">
                                        <!-- Card Header -->
                                        <div class="card-header bg-inherit border-0 p-0">
                                            <h2 class="mb-0">
                                                <button class="btn px-0 py-3" type="button">
                                                    Is the template well-documented?
                                                </button>
                                            </h2>
                                        </div>
                                        <!-- Card Body -->
                                        <div class="card-body px-0 py-3">
                                            There are many variations of passages of Lorem Ipsum available, but the majority have suffered alteration in some form, by injected humour, or randomised words which don't look even slightly believable. If you are going to use a passage of Lorem Ipsum, you need to be sure there isn't anything embarrassing hidden in the middle of text.
                                        </div>
                                    </div>
                                    <!-- Single Card -->
                                    <div class="card border-0">
                                        <!-- Card Header -->
                                        <div class="card-header bg-inherit border-0 p-0">
                                            <h2 class="mb-0">
                                                <button class="btn px-0 py-3" type="button">
                                                    Can I get direct support from the author?
                                                </button>
                                            </h2>
                                        </div>
                                        <!-- Card Body -->
                                        <div class="card-body px-0 py-3">
                                            There are many variations of passages of Lorem Ipsum available, but the majority have suffered alteration in some form, by injected humour, or randomised words which don't look even slightly believable. If you are going to use a passage of Lorem Ipsum, you need to be sure there isn't anything embarrassing hidden in the middle of text.
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="row justify-content-center">
                                <p class="text-body text-center pt-4 fw-5">Haven't find suitable answer? <a href="#">Tell us what you need.</a></p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
export default {

}
</script>

<style>

</style>